/** Feed page strings (PREC-3635) — the standalone /app/feed surface. */
export const enFeed = {
	title: "Feed",
	tabs: {
		new: "New",
		review: "To be reviewed",
		assigned: "Assigned",
		ignored: "Ignored",
		trackedProfiles: "Tracked Profiles",
	},
	searchPlaceholder: "Search for name or company name …",
	// The L3 score filters reuse the list page's labels (inbox.priorityFilterOptions /
	// inbox.signalFilterOptions) — same dropdown, same vocabulary.
	listSelection: {
		none: "No lists",
		multiple: "{{count}} lists",
		searchPlaceholder: "Search lists …",
		openSettings: "Open the settings of {{name}}",
	},
	// Topbar list-action cluster (PREC-3698) — it targets one tracker, so it collapses to a
	// disabled settings pill when the selection is empty or holds several.
	actions: {
		listSettings: "List Settings",
		singleTrackerOnly: "Select a single tracker to open its settings",
	},
	jump: {
		trigger: "Jump to a company",
		title: "Jump to company",
		sortBy: "Sort by:",
		sortStrength: "Signal strength",
		sortDate: "Date (latest first)",
		empty: "No companies to jump to.",
	},
	runCard: {
		prioTier: "{{tier}} Signal",
		prioMeaningStrong: "Clear buying intent",
		prioMeaningSoft: "Worth to reach out",
		evidenceSince: "Most relevant signals since {{date}}",
		showMore_one: "Show {{count}} more signal",
		showMore_other: "Show {{count}} more signals",
		showFewer: "Show fewer signals",
		switchPerson: "Switch",
		// The Switch menu's Profiles rows (PREC-5041) — the company's people from the Profiles tab.
		switchMenu: {
			loading: "Loading the company's people…",
			loadError: "Couldn't load the company's people.",
			addAsLead: "Add as lead",
			addingIndication: "Adding…",
			onListHidden: "On the list — hidden by filters",
			addPerson: "Add Person",
			addError: "Couldn't add this person. Please try again.",
			addedHiddenByFilters: "Added to the list, but hidden by the feed's filters.",
		},
		trackedCount: "{{count}} tracked",
		ignoreRun: "Ignore this time",
		ignoredToast: "Ignored {{company}} this time",
		// The footer (…) overflow menu — card-level actions that have no dedicated button.
		menu: {
			trigger: "More actions",
			reviewLater: "Review later",
			backToNew: "Move back to New",
			moveToIgnored: "Move to Ignored",
			addToProvider: "Add to {{provider}}",
			removePerson: "Remove {{name}} from Profile Tracker",
			removePersonFallback: "Remove from Profile Tracker",
			stopTrackingCompany: "Stop tracking {{company}}",
			stopTrackingCompanyFallback: "Stop tracking this company",
			reviewLaterToast: "Saved {{name}} for later review",
			backToNewToast: "Moved {{name}} back to New",
			moveToIgnoredToast: "Moved {{name}} to Ignored",
			statusError: "Couldn't update the lead. Please try again.",
			removePersonTitle: "Remove from Profile Tracker",
			removePersonBody:
				"Remove {{name}} from the Profile Tracker? Their signals will stop appearing in the feed.",
			removePersonConfirm: "Remove",
			removePersonToast: "Removed {{name}} from the Profile Tracker",
			removeCompanyTitle: "Stop tracking company",
			removeCompanyBody:
				"Stop tracking {{company}}? All of its tracked people and signals will be removed from the feed.",
			removeCompanyConfirm: "Stop tracking",
			removeCompanyToast: "Stopped tracking {{company}}",
			removeError: "Couldn't complete the removal. Please try again.",
		},
		employees: "{{count}} employees",
		enrichment: {
			linkedin: "LinkedIn",
			email: "Email",
			phone: "Phone",
			website: "Website",
		},
		relationship: {
			inCampaign: "In campaign",
			previousOutreach: "Previous outreach",
			connectedOnLinkedin: "Connected on LinkedIn",
		},
		strength: {
			menuTitle: "Change signal score",
			menuFooter: "Helps improve scoring",
			s1: "Strong signal",
			s2: "Moderate signal",
			s3: "Low priority",
			dq: "Not relevant",
			changed: "Signal score changed to {{score}}",
			addReason: "Add reason",
			undo: "Undo",
			reasonTitle: "Change signal score",
			reasonDescription: "This feedback trains the AI scoring model.",
			reasonLabel: "Why are you changing this score?",
			reasonPlaceholder: "e.g. This signal is old news for this account…",
			reasonRequired: "Please enter at least 3 characters",
			reasonSubmit: "Save",
		},
		source: {
			label: "Source",
			open: "View original",
		},
		signal: {
			whyTitle: "Why this is relevant / what to mention",
			readMore: "Read more",
			showLess: "Show less",
			ignoreSignal: "Ignore signal",
			openOriginal: "Open original",
		},
	},
	// The idle menu is the shared list-page reach-out menu (list.reachOut.*).
	reachOut: {
		button: "Reach out to {{name}}",
		generating: "Generating for {{name}}…",
		queued: "Queued — {{name}}",
		ready: "AI drafts ready for {{name}} — review now",
		done: "AI drafts created for {{name}} — open chat",
	},
	aiQueue: {
		title: "AI sequence generation",
		generating_one: "{{count}} generating",
		generating_other: "{{count}} generating",
		ready_one: "{{count}} AI draft ready",
		ready_other: "{{count}} AI drafts ready",
		statusGenerating: "Generating…",
		statusQueued: "Queued",
		review: "Review",
		// One-shot toast when a generation finishes (P6 — "once it's done").
		draftsReadyToast: "AI drafts are ready",
	},
	signalCta: {
		mention: "Let AI mention this signal in a sequence",
		draft: "Let AI draft a message based on this signal",
		generating: "Generating…",
		queued: "Queued",
		ready: "AI drafts are ready — review now",
	},
	conflict: {
		inFlightTitle: "Generation already in progress",
		inFlightBody:
			"A sequence for {{name}} is already being generated from a different signal. You can use this signal as a new angle once those drafts are ready.",
		inFlightOk: "OK — keep the current generation",
		readyTitle: "Replace the ready drafts?",
		readyBody:
			"AI drafts for {{name}} are ready from a different signal. Replace them and use this signal as the new angle instead?",
		readyReplace: "Replace and regenerate",
		readyKeep: "Keep the current drafts",
	},
	emptyStates: {
		noTrackerListsTitle: "No Profile Tracker lists yet",
		noTrackerListsDescription: "Create a Profile Tracker list to see its signal runs in the feed.",
		noTrackerListsCta: "Go to Profile Tracker",
		noCompanies: "No companies in this tab for the current selection.",
	},
};
